import { useContext, useEffect } from "react";
import { SetBackButtonVisibilityContext } from "../context/ThemeContext";

export function useShowBackButton(id: unknown) {
  const setBackButtonVisibility = useContext(SetBackButtonVisibilityContext);

  useEffect(() => {
    if (id) {
      setBackButtonVisibility(true);
    } else {
      setBackButtonVisibility(false);
    }
  }, [id, setBackButtonVisibility]);
}
